import Vue from 'vue';
import VueRouter from 'vue-router';
import Customer from '@/views/Customer/Customer';
import CustomerTreeview from '@/views/Customer/CustomerTreeview';
import AdminProviderUsers from '@/views/Admin/AdminProviderUsers';
import Provider from '@/views/Provider/Provider';
import Exchange from '@/views/Provider/Exchange';
import ProviderTreeview from '@/views/Provider/ProviderTreeview';
import Admin from '@/views/Admin/Admin';
import AdminProviders from '@/views/Admin/AdminProviders';
import AdminCustomers from '@/views/Admin/AdminCustomers';
import AdminCustomerUsers from '@/views/Admin/AdminCustomerUsers';
import OperatorStorage from '@/views/Operator/OperatorStorage';
import Operator from '@/views/Operator/Operator';
import ProviderStorage from '@/views/Operator/ProviderStorage';
import ExchangeStorage from '@/views/Operator/ExchangeStorage';
import ShareFolder from '@/views/ShareFolder';
import store from '@/store/index';
import MakeDeliverableList from '@/views/MakeDeliverableList';

Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    redirect: () => {
      switch (store.state.userRole) {
        case "Admin": {
          return { path: '/admin' }
        }
        case "Operator": {
          return { path: '/operator' }
        }
        case "Provider": {
          return { path: '/provider' }
        }
        case "Customer": {
          return { path: '/customer' }
        }
      }
    }
  },
  {
    path: '/admin-provider-users/:organization',
    name: 'admin-provider-users',
    component: AdminProviderUsers,
    meta: {
      title: 'Admin-Provider-Users',
      requiredGroups: ['Admin']
    }
  },
  {
    path: '/provider',
    name: 'provider',
    component: Provider,
    meta: {
      title: 'Provider',
      requiredGroups: ['Provider']
    }
  },
  {
    path: '/exchange',
    name: 'exchange',
    component: Exchange,
    meta: {
      title: 'Exchange',
      requiredGroups: ['Provider']
    }
  },
  {
    path: '/provider-treeview',
    name: 'provider-treeview',
    component: ProviderTreeview,
    meta: {
      title: 'ProviderTreeview',
      requiredGroups: ['Provider']
    }
  },
  {
    path: '/admin',
    name: 'admin',
    component: Admin,
    meta: {
      title: 'Admin',
      requiredGroups: ['Admin']
    }
  },
  {
    path: '/admin-providers',
    name: 'admin-providers',
    component: AdminProviders,
    meta: {
      title: 'AdminProviders',
      requiredGroups: ['Admin']
    }
  },
  {
    path: '/admin-customer-users/:company',
    name: 'admin-customer-users',
    component: AdminCustomerUsers,
    meta: {
      title: 'Admin-Customer-Users',
      requiredGroups: ['Admin']
    }
  },
  {
    path: '/admin-customers',
    name: 'admin-customers',
    component: AdminCustomers,
    meta: {
      title: 'AdminCustomers',
      requiredGroups: ['Admin']
    }
  },
  {
    path: '/customer',
    name: 'customer',
    component: Customer,
    meta: {
      title: 'Customer',
      requiredGroups: ['Customer']
    }
  },
  {
    path: '/customer-treeview',
    name: 'customer-treeview',
    component: CustomerTreeview,
    meta: {
      title: 'CustomerTreeview',
      requiredGroups: ['Customer']
    }
  },
  {
    path: '/operator',
    name: 'operator',
    component: Operator,
    meta: {
      title: 'Operator',
      requiredGroups: ['Operator', 'Admin']
    }
  },
  {
    path: '/operator-storage',
    name: 'operator-storage',
    component: OperatorStorage,
    meta: {
      title: 'OperatorStorage',
      requiredGroups: ['Operator', 'Admin']
    }
  },
  {
    path: '/provider-storage',
    name: 'provider-storage',
    component: ProviderStorage,
    meta: {
      title: 'ProviderStorage',
      requiredGroups: ['Operator', 'Admin']
    }
  },
  {
    path: '/exchange-storage',
    name: 'exchange-storage',
    component: ExchangeStorage,
    meta: {
      title: 'ExchangeStorage',
      requiredGroups: ['Operator', 'Admin']
    }
  },
  {
    path: '/share-folder/:provider',
    name: 'share-folder',
    component: ShareFolder,
    meta: {
      title: 'Share-Folder',
      requiredGroups: ['Operator', 'Provider', 'Admin']
    }
  },
  {
    path: '/batch-requests',
    name: 'batch-requests',
    component: MakeDeliverableList,
    meta: {
      title: 'Batch-Requests',
      requiredGroups: ['Operator', 'Admin']
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
});


const evaluateRouting = (authInfo = {}) => {
  const requiredGroups = (authInfo.requiredGroups || []);
  return requiredGroups;
};

const routerGuard = store => async (to, from, next) => {
  if (!store.state.userRole) {
    await store.dispatch('setUser');
  }
  const meta = to.meta || {};
  const requiredGroups = evaluateRouting(meta);
  let can_pass = false;
  if (requiredGroups.length === 0) {
    next();
  }
  requiredGroups.forEach(el => {
    if (el === store.state.userRole) {
      can_pass = true;
    }
  });
  if (can_pass) {
    await next();
  } else {
    next('/');
  }
};
router.beforeEach(routerGuard(store));
export default router;